import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { AuthProvider } from "./AuthContext";

import App from "./App";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>
);